export const LOCAL_STORAGE_KEYS = {
  CURRENT_USER: 'currentUser',
  BUSINESS_INFO: 'businessInfo',
  TOKEN_EXPIRATION: 'tokenExpiration',
  BROCHURE_DATA: 'brochureData',
  GOOGLE_BANNER_STATUS_KEY: 'showGoogleBanner',
  REVIEW_CLINIC_ID: 'reviewClinicId',
  BUSINESS_CONFIG: 'businessConfig',
  RETURN_URL: 'returnUrl',
  AVAILABLE_BUSINESSES: 'availableBusinesses',
  SESSION_START_TIME: 'sessionStartTime',
  // Identifies this browser profile's tracked session. Deliberately localStorage and not
  // sessionStorage: one profile is one session, so a second tab does not mint a second one.
  ANALYTICS_SESSION_KEY: 'analyticsSessionKey',
  // Must persist with the key above: an in-memory counter restarts on every page refresh
  // and numbers a second event 1 inside the same session.
  ANALYTICS_SESSION_SEQ: 'analyticsSessionSeq',
};
